import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

export interface TechnicalError {
  subsystemName: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorService {
  private readonly errorSubject = new Subject<TechnicalError>()
  public error$ = this.errorSubject.asObservable()

  public reportError(error: TechnicalError): void {
    this.errorSubject.next(error)
  }
}
